export default __webpack_public_path__ + "static/media/arrow-down-2.9ac2da07.svg";